import { render } from "./PopupAlert.vue?vue&type=template&id=f172345c"
import script from "./PopupAlert.vue?vue&type=script&lang=js"
export * from "./PopupAlert.vue?vue&type=script&lang=js"

import exportComponent from "/ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__